"use client"

import { currentBridgeGeneration } from "@/platform/bridge/document-events"

import { removeDatadogGlobalProperty, setDatadogGlobalProperty } from "./context"

export const NATIVE_RUM_SESSION_PROPERTY = "nelo_native_rum_session_id"

export const applyNativeRumSession = (data: Record<string, unknown>, generation = currentBridgeGeneration()): boolean => {
  if (generation !== currentBridgeGeneration()) return false
  const sessionId = data.sessionId
  if (typeof sessionId !== "string" || sessionId.length === 0) return false

  const canonicalSessionId = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(sessionId) ? sessionId.toLowerCase() : sessionId
  setDatadogGlobalProperty(NATIVE_RUM_SESSION_PROPERTY, canonicalSessionId)
  return true
}

export const clearNativeRumSession = (): void => removeDatadogGlobalProperty(NATIVE_RUM_SESSION_PROPERTY)
